module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("biCJU"))).then(() => module.bundle.root('d0iPb'));